import React from 'react';
import Home from './components/home';

import './assets/App.css';

function App() {
  return (
    <Home />
  );
}

export default App;
